import { Injectable } from '@angular/core';

@Injectable()
export class Globals {
  apiUrl: string = 'https://admin.inmobiliarianieblas.com';
  // apiUrl: string = 'http://localhost:1337';
}
